<template>
    <a href="javascript:void(0)" :class="current" :data-scp="scp" @click.stop="edit()">
        <span style="display: block;" v-text="text"></span>
    </a>
</template>
<script>
    import maple from 'maple';

    export default {
        props: ['current', 'scp']
        , ready: function () {
            this.$set('text', this.$root.text);
        },
        methods: {
            edit: function () {
                this.$dispatch('edit');
            }
        },
        events:{
            editText: function(text){	// 父级决定返回按钮是否可用
                this.text = text;
            }
        }
    };
</script>